import styled from "@emotion/styled"
import CustomImage from "../../components/custom-image/custom-image.component"
import { Container, Typography } from "@mui/material"
import SectionWrapper from "../../components/section-wrapper/section-wrapper.component"

export const Section = styled(SectionWrapper)`
  position: relative;
  z-index: 2;
  padding-top: ${({ theme }) => theme.typography.pxToRem("186")};
  padding-bottom: 12rem;

  ${({ theme }) => theme.breakpoints.up("md")} {
    padding-top: ${({ theme }) => theme.typography.pxToRem("224")};
    padding-bottom: 14rem;
  }
`
export const BgImage = styled(CustomImage)`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;

  ::after {
    content: "";
    position: absolute;
    inset: 0;
    background-color: ${({ bgcolor }) => bgcolor ?? "rgba(0,0,0,0.5)"};
    border-radius: 0px 0px 24px 24px;
    ${({ theme }) => theme.breakpoints.up("md")} {
      border-radius: 0px 0px 49px 40px;
    }
  }

  > .gatsby-image-wrapper {
    height: 100%;
    img {
      border-radius: 0px 0px 24px 24px;
      ${({ theme }) => theme.breakpoints.up("md")} {
        border-radius: 0px 0px 49px 40px;
      }
    }
  }
`
export const Wrapper = styled(Container)`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
`

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  justify-content: space-between;
  margin-top: 1.75rem;
  max-width: 750px;
  align-items: center;
  gap: 0.75rem;

  ${({ theme }) => theme.breakpoints.up("sm")} {
    gap: 2.5rem;
  }
`

export const Title = styled(Typography)`
  font-family: ${({ theme }) => theme.fonts.secondary};
  color: ${({ theme }) => theme.palette.text.light};
  text-align: center;
  font-size: 2.25rem;
  line-height: 2.75rem;

  ${({ theme }) => theme.breakpoints.up("sm")} {
    font-size: 3.75rem;
    line-height: 4.8125rem;
  }
`

export const Description = styled.div`
  color: ${({ theme }) => theme.palette.text.light};
  text-align: center;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.5rem;
  letter-spacing: 0.015rem;

  p {
    :last-of-type {
      margin-bottom: 0;
    }
    :first-of-type {
      margin-top: 0;
    }
  }

  a {
    color: ${({ theme }) => theme.palette.text.light};
  }
  ${({ theme }) => theme.breakpoints.up("sm")} {
    font-weight: 400;
    font-size: 1.0625rem;
    line-height: 1.75rem;
    letter-spacing: 0.01063rem;
    text-align: center;
  }
`
